const bookChoicesRo = [
  {
    label: "Aventuri captivante și povești ușoare și plăcute.",
    value:
      'Exciting adventures and light enjoyable stories.{"Red":"3","Yellow":"2"}',
  },
  {
    label: "Povești întunecate și lucrări filozofice, contemplative.",
    value:
      'Mysteries and dark stories and philosophical, contemplative works.{"Black":"3","Gray":"2"}',
  },

  {
    label: "Povești inspiratoare de reziliență și narațiuni emoționante despre familie.",
    value:
      'Inspiring stories of resilience and moving family narratives.{"Green":"3","Brown":"2"}',
  },

  {
    label:
      "Romane profunde, contemplative și povești de fantezie cu elemente magice.",
    value:
      'Deep, contemplative novels and fantasy stories with magical elements.{"Blue":"3","Violet":"2"}',
  },
];

export default bookChoicesRo;
